import ApiService from '@/common/api.service'
import * as action from '@/store/action.types'
import {
  ADD_EVENT_URL,
  GET_EVENTS_URL,
  GET_PAYMENTS_URL,
  GET_VISITATIONS_URL,
  GET_VISITATIONS_URL_V2,
  DELETE_VISITATION_URL,
  ADD_NEW_VISITATION_URL,
  GET_SINGLE_EVENT_URL,
  DELETE_SINGLE_EVENT_URL,
  EDIT_SINGLE_EVENT_URL,
  EXPORT_CALENDAR_URL,
  GET_HOLIDAYS_URL
} from '@/constants/ApiConstants'

const state = {}

const getters = {}

const actions = {
  [action.ADD_EVENT](_, data) {
    return ApiService.post(ADD_EVENT_URL, data);
  },
  [action.GET_EVENTS](_, data) {
    return ApiService.post(GET_EVENTS_URL, data);
  },
  [action.GET_PAYMENTS](_, data) {
    return ApiService.post(GET_PAYMENTS_URL, data);
  },
  [action.GET_VISITATIONS](_, data) {
    return ApiService.post(GET_VISITATIONS_URL, data);
  },
  [action.GET_VISITATIONS_V2](_, data) {
    return ApiService.post(GET_VISITATIONS_URL_V2, data);
  },
  [action.ADD_NEW_VISITATION](_, data) {
    return ApiService.post(ADD_NEW_VISITATION_URL, data);
  },
  [action.DELETE_VISITATION](_, data) {
    return ApiService.post(DELETE_VISITATION_URL, data);
  },
  [action.GET_SINGLE_EVENT](_, data) {
    return ApiService.get(GET_SINGLE_EVENT_URL.replace(':guid', data.guid));
  },
  [action.DELETE_SINGLE_EVENT](_, guid) {
    return ApiService.delete(DELETE_SINGLE_EVENT_URL.replace(':guid', guid));
  },
  [action.EDIT_SINGLE_EVENT](_, data) {
    return ApiService.putData(EDIT_SINGLE_EVENT_URL.replace(':guid', data.guid), data);
  },
  [action.EXPORT_CALENDAR](_, data) {
    return ApiService.post(EXPORT_CALENDAR_URL, data);
  },
  [action.GET_HOLIDAYS](_, data) {
    return ApiService.post(GET_HOLIDAYS_URL, data);
  }
}

export default {
  state,
  actions,
  getters
}
